interface ComputerWithGearAndCircuitsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithGearAndCircuitsSVG = ({
  color,
  style,
}: ComputerWithGearAndCircuitsSVGProps) => (
  <svg
    style={style}
    width="50"
    height="52"
    viewBox="0 0 50 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.29297 9.40118H41.8129C43.4996 9.40118 44.8713 10.7703 44.8713 12.4597V38.5022H3.2345V12.4597C3.2345 10.7729 4.60365 9.40118 6.29297 9.40118Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.0236 34.871V12.3295H6.08472V34.871H42.0236Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.30301 38.4995H47.5783C47.607 38.4995 47.633 38.5229 47.633 38.5542V39.5121C47.633 40.7563 46.623 41.7688 45.3762 41.7688H3.55977C2.29994 41.7688 1.27698 40.7459 1.27698 39.486V38.5281C1.27698 38.5125 1.28999 38.5021 1.30301 38.5021V38.4995Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.403 28.7932H18.2847"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2821 28.7931C18.2821 29.5272 17.686 30.1232 16.952 30.1232C16.218 30.1232 15.6219 29.5272 15.6219 28.7931C15.6219 28.0591 16.218 27.463 16.952 27.463C17.686 27.463 18.2821 28.0591 18.2821 28.7931Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9725 24.8835H16.4548V22.9495H20.682"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9778 24.7976C11.9778 25.6046 11.3218 26.2605 10.5149 26.2605C9.70794 26.2605 9.052 25.6046 9.052 24.7976C9.052 23.9907 9.70794 23.3348 10.5149 23.3348C11.3218 23.3348 11.9778 23.9907 11.9778 24.7976Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.403 19.0321H16.0566"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7265 20.3622C15.4611 20.3622 16.0566 19.7667 16.0566 19.0321C16.0566 18.2975 15.4611 17.702 14.7265 17.702C13.9919 17.702 13.3964 18.2975 13.3964 19.0321C13.3964 19.7667 13.9919 20.3622 14.7265 20.3622Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6173 23.6003C36.6173 23.202 36.5756 22.8142 36.5054 22.4368L38.1036 21.1431C37.9266 20.5835 37.6923 20.0317 37.3878 19.5033C37.0806 18.9723 36.7214 18.4959 36.3258 18.0612L34.4048 18.7979C33.8165 18.2929 33.1345 17.8972 32.3901 17.6343L32.0673 15.6014C31.4947 15.4739 30.8986 15.401 30.2869 15.401C29.6752 15.401 29.0817 15.4739 28.5065 15.6014L28.1837 17.6343C27.4393 17.8972 26.7573 18.2929 26.169 18.7979L24.2481 18.0612C23.8524 18.4933 23.4906 18.9723 23.1861 19.5033C22.8789 20.0343 22.6446 20.5835 22.4703 21.1431L24.0685 22.4368C23.9982 22.8142 23.9565 23.202 23.9565 23.6003C23.9565 23.9985 23.9982 24.3864 24.0685 24.7638L22.4703 26.0575C22.6473 26.6171 22.8815 27.1689 23.1861 27.6973C23.4932 28.2283 23.8524 28.7047 24.2481 29.1394L26.169 28.4027C26.7573 28.9077 27.4393 29.3034 28.1837 29.5637L28.5065 31.5966C29.0791 31.7241 29.6752 31.797 30.2869 31.797C30.8986 31.797 31.4921 31.7241 32.0673 31.5966L32.3901 29.5637C33.1345 29.3008 33.8165 28.9051 34.4048 28.4027L36.3258 29.1394C36.7214 28.7073 37.0832 28.2283 37.3878 27.6973C37.6923 27.1663 37.9292 26.6171 38.1036 26.0575L36.5054 24.7638C36.5756 24.3864 36.6173 23.9985 36.6173 23.6003Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.2869 27.0569C32.196 27.0569 33.7436 25.5093 33.7436 23.6002C33.7436 21.6911 32.196 20.1435 30.2869 20.1435C28.3778 20.1435 26.8302 21.6911 26.8302 23.6002C26.8302 25.5093 28.3778 27.0569 30.2869 27.0569Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ComputerWithGearAndCircuitsSVG;
